import {
  Component,
  Host,
  h,
  Prop,
} from "@stencil/core";

import { Space, Layout } from "../../index";

/**
 * @slot - Slot for any elements that should be horizontically spaced
 */
@Component({
  tag: "stzh-hspace",
  styleUrl: "stzh-hspace.scss",
  shadow: true
})
export class StzhHspace {
  /** Type of curve (see [Spacings docs page](/docs/tokens-spacings--docs#curves) for more info). */
  @Prop({ reflect: true }) curve: Space.Curves = "none";

  /** Type of size (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) size: Space.Sizes;
  /** Type of size above small breakpoint (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) sizeSmall: Space.Sizes;
  /** Type of size above medium breakpoint (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) sizeMedium: Space.Sizes;
  /** Type of size above large breakpoint (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) sizeLarge: Space.Sizes;
  /** Type of size above ultra breakpoint (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) sizeUltra: Space.Sizes;

  /** Alignment */
  @Prop({ reflect: true }) justify: Layout.Justify = "start";

  /** Control how cells items are positioned along a container's cross axis */
  @Prop({ reflect: true }) items: Layout.Items = "start";

  /** Apply spacing to slotted elements (padding instead of margin) */
  @Prop({ reflect: true }) around: boolean = false;

  /** Apply spacing to slotted elements (padding instead of margin, only left) */
  @Prop({ reflect: true }) aroundLeft: boolean = false;

  /** Apply spacing to slotted elements (padding instead of margin, only right) */
  @Prop({ reflect: true }) aroundRight: boolean = false;

  /** Add border */
  @Prop({ reflect: true }) border: "none" | "left" | "right" | "left-right" = "none";

  render() {
    return (
      <Host>
        <div
          class={{
            "stzh-hspace": true,
            [`stzh-hspace--justify-${this.justify}`]: !!this.justify,
            [`stzh-hspace--items-${this.items}`]: !!this.items
          }}
        >
          <slot></slot>
        </div>
      </Host>
    );
  }
}
